module.exports = __webpack_public_path__ + "img/allergy-dairy.7261a09c.png";